import { Link } from 'react-router-dom';
import './Services.css';

export default function Services() {
  return (
    <main id="top">

      <section className="svc-hero">
        <div className="wrap-wide">
          <nav className="crumb"><Link to="/">Home</Link><span className="sep">/</span><b>Services & Certifications</b></nav>
          <div className="grid">
            <div className="copy">
              <span className="eyebrow">A complete federal contracting practice</span>
              <h1>Every service and certification you need to win federal work.</h1>
              <p className="sub">From your first SAM.gov registration to SBA certification, capability statements, proposal writing, and bid submission ATZ Solution manages the full path into the federal marketplace, under one roof.</p>
              <div className="ha">
                <a className="btn btn-primary" href="/contact-us/">Book a Free Consultation <span className="arw">→</span></a>
                <a className="btn btn-ghost" href="#services">Explore All Services</a>
              </div>
              <div className="meta">
                <span className="stars"><svg className="ico"><use href="#i-star" /></svg><svg className="ico"><use href="#i-star" /></svg><svg className="ico"><use href="#i-star" /></svg><svg className="ico"><use href="#i-star" /></svg><svg className="ico"><use href="#i-star" /></svg></span>
                <span><b>4.9/5</b> · 2,400+ businesses registered & certified</span>
              </div>
            </div>
            <div className="media">
              <img className="ph" src="/images/capitol-dome-flag.jpg" alt="U.S. Capitol — federal services overview" style={{ height: '539px', width: '494px' }} />
              <div className="fact"><b>One partner</b><span>for registration, certification & contract pursuit</span></div>
            </div>
          </div>
        </div>
      </section>

      <section className="uspbar">
        <div className="wrap-wide">
          <div className="u"><svg className="ico"><use href="#i-landmark" /></svg><span className="ut"><b>U.S.-Based Experts</b><span>Dedicated federal specialists</span></span></div>
          <div className="u"><svg className="ico"><use href="#i-shield" /></svg><span className="ut"><b>98% Success Rate</b><span>Filed accurately, first time</span></span></div>
          <div className="u"><svg className="ico"><use href="#i-clock" /></svg><span className="ut"><b>Fast Turnaround</b><span>Most filings in 24–48 hrs</span></span></div>
          <div className="u"><svg className="ico"><use href="#i-refresh" /></svg><span className="ut"><b>Ongoing Support</b><span>Renewals & compliance handled</span></span></div>
        </div>
      </section>

      <section className="services sec-pad" id="services">
        <div className="wrap-wide">
          <div className="sec-head">
            <span className="kicker-num">Our services</span>
            <h2>One firm for the entire federal contracting journey.</h2>
            <p className="lead">Whether you are registering for the first time or scaling across agencies, every service below is delivered by a specialist who knows exactly what federal reviewers require.</p>
          </div>
          <div className="msvc-grid">

            <article className="svc6 feature">
              <div className="feat-media"><img className="ph" src="/images/specialist-sam-filing.jpg" alt="Specialist preparing a SAM.gov filing" /></div>
              <div className="feat-body">
                <span className="iconwrap"><svg className="ico"><use href="#i-doc" /></svg></span>
                <span className="tag">Most requested</span>
                <h3>SAM.gov Registration & Renewal</h3>
                <p>Complete entity registration and UEI acquisition that gets your business active, validated, and visible to every federal buyer prepared and submitted on your behalf, correct the first time, with renewals handled so you never lapse.</p>
                <Link className="more" to="/sam-registration/">Learn about SAM.gov Registration <span className="arw">→</span></Link>
              </div>
            </article>

            <article className="svc6">
              <span className="iconwrap"><svg className="ico"><use href="#i-award" /></svg></span>
              <h3>SBA Certifications</h3>
              <p>8(a), WOSB/EDWOSB, HUBZone, and SDVOSB applications prepared and shepherded through SBA review to approval.</p>
              <a className="more" href="#certifications">View certifications <span className="arw">→</span></a>
            </article>

            <article className="svc6">
              <span className="iconwrap"><svg className="ico"><use href="#i-clipboard" /></svg></span>
              <h3>Capability Statement</h3>
              <p>A clear, federal-ready document presenting your capabilities, NAICS codes, and past performance to contracting officers and prime contractors.</p>
              <a className="more" href="/contact-us/">Request a capability statement <span className="arw">→</span></a>
            </article>

            <article className="svc6">
              <span className="iconwrap"><svg className="ico"><use href="#i-trophy" /></svg></span>
              <h3>Proposal Writing</h3>
              <p>Compliant, persuasive proposals tailored to each solicitation built to meet evaluation criteria and give your bid the strongest possible chance to win.</p>
              <a className="more" href="/contact-us/">Get proposal support <span className="arw">→</span></a>
            </article>

            <article className="svc6">
              <span className="iconwrap"><svg className="ico"><use href="#i-send" /></svg></span>
              <h3>Bid Submission & Management</h3>
              <p>We track opportunities, prepare your submission packages, and manage deadlines on SAM.gov and agency portals so no bid is missed or rejected on a technicality.</p>
              <a className="more" href="/contact-us/">Manage my bids <span className="arw">→</span></a>
            </article>

            <article className="svc6">
              <span className="iconwrap"><svg className="ico"><use href="#i-target" /></svg></span>
              <h3>Consulting & Strategy</h3>
              <p>Direct guidance on NAICS positioning, set-aside targeting, and the specific steps your business needs to compete and win in the federal market.</p>
              <a className="more" href="/contact-us/">Talk strategy <span className="arw">→</span></a>
            </article>

            <article className="svc6">
              <span className="iconwrap"><svg className="ico"><use href="#i-refresh" /></svg></span>
              <h3>Renewals & Compliance</h3>
              <p>Annual renewals, reps & certs, and active monitoring so your registration and certifications never lapse and you stay continuously contract-ready.</p>
              <a className="more" href="/contact-us/">Stay compliant <span className="arw">→</span></a>
            </article>

            <article className="svc6">
              <span className="iconwrap"><svg className="ico"><use href="#i-landmark" /></svg></span>
              <h3>GSA Schedule Readiness</h3>
              <p>Preparation and onboarding support for a GSA Multiple Award Schedule opening long-term contract vehicles across federal agencies.</p>
              <a className="more" href="/contact-us/">Explore GSA readiness <span className="arw">→</span></a>
            </article>

            <article className="svc6">
              <span className="iconwrap"><svg className="ico"><use href="#i-megaphone" /></svg></span>
              <h3>Federal Outreach & Marketing</h3>
              <p>We represent your business in agency outreach and connect you to subcontract opportunities through our prime contractor portfolio.</p>
              <a className="more" href="/contact-us/">Grow my pipeline <span className="arw">→</span></a>
            </article>

          </div>
        </div>
      </section>

      <section className="certs certs-all sec-pad" id="certifications" style={{ background: 'var(--surface-2)', borderTop: '1px solid var(--rule)' }}>
        <div className="wrap-wide">
          <div className="sec-head">
            <span className="kicker-num">Federal & state certifications</span>
            <h2>Every certification that sets your business apart.</h2>
            <p className="lead">From SBA set-asides to cybersecurity and state-level programs, we determine exactly what you qualify for and manage every application end to end.</p>
          </div>
          <div className="cert-grid">
            <article className="cert">
              <span className="badge"><svg className="ico"><use href="#i-target" /></svg></span>
              <h3>CMMC 1 & 2</h3>
              <div className="sub">Cybersecurity · DoD</div>
              <p>Cybersecurity Maturity Model Certification, Levels 1 & 2, for Department of Defense contractors.</p>
              <a className="lk" href="/contact-us/">Check eligibility <span className="arw">→</span></a>
            </article>
            <article className="cert">
              <span className="badge"><svg className="ico"><use href="#i-award" /></svg></span>
              <h3>8(a) Certification</h3>
              <div className="sub">Business Development</div>
              <p>SBA's nine-year Business Development program for socially & economically disadvantaged firms.</p>
              <a className="lk" href="/contact-us/">Check eligibility <span className="arw">→</span></a>
            </article>
            <article className="cert">
              <span className="badge"><svg className="ico"><use href="#i-landmark" /></svg></span>
              <h3>Disadvantaged Business Enterprise</h3>
              <div className="sub">DBE · DOT</div>
              <p>For disadvantaged-owned firms bidding on U.S. Department of Transportation–funded projects.</p>
              <a className="lk" href="/contact-us/">Check eligibility <span className="arw">→</span></a>
            </article>
            <article className="cert">
              <span className="badge"><svg className="ico"><use href="#i-clipboard" /></svg></span>
              <h3>General Services Administration</h3>
              <div className="sub">GSA Schedule</div>
              <p>GSA Multiple Award Schedule — a long-term contract vehicle for selling across federal agencies.</p>
              <a className="lk" href="/contact-us/">Check eligibility <span className="arw">→</span></a>
            </article>
            <article className="cert">
              <span className="badge"><svg className="ico"><use href="#i-mappin" /></svg></span>
              <h3>HUBZone</h3>
              <div className="sub">Underutilized Zone</div>
              <p>Historically Underutilized Business Zone program for firms located in qualifying areas.</p>
              <a className="lk" href="/contact-us/">Check eligibility <span className="arw">→</span></a>
            </article>
            <article className="cert">
              <span className="badge"><svg className="ico"><use href="#i-users" /></svg></span>
              <h3>Minority Business Enterprise</h3>
              <div className="sub">MBE · Minority-Owned</div>
              <p>Certification for businesses that are at least 51% owned and operated by minority individuals.</p>
              <a className="lk" href="/contact-us/">Check eligibility <span className="arw">→</span></a>
            </article>
            <article className="cert">
              <span className="badge"><svg className="ico"><use href="#i-shield" /></svg></span>
              <h3>Service-Disabled Veteran Small Business</h3>
              <div className="sub">SDVOSB · Veteran-Owned</div>
              <p>For small businesses owned and controlled by service-disabled veterans.</p>
              <a className="lk" href="/contact-us/">Check eligibility <span className="arw">→</span></a>
            </article>
            <article className="cert">
              <span className="badge"><svg className="ico"><use href="#i-shield" /></svg></span>
              <h3>Veteran Owned</h3>
              <div className="sub">VOSB · Veteran-Owned</div>
              <p>Veteran-Owned Small Business certification for firms led by U.S. military veterans.</p>
              <a className="lk" href="/contact-us/">Check eligibility <span className="arw">→</span></a>
            </article>
            <article className="cert">
              <span className="badge"><svg className="ico"><use href="#i-star" /></svg></span>
              <h3>Women Business Enterprise</h3>
              <div className="sub">WBE · Women-Owned</div>
              <p>Certification for businesses at least 51% owned, operated, and controlled by women.</p>
              <a className="lk" href="/contact-us/">Check eligibility <span className="arw">→</span></a>
            </article>
            <article className="cert">
              <span className="badge"><svg className="ico"><use href="#i-star" /></svg></span>
              <h3>Women-Owned Small Business</h3>
              <div className="sub">WOSB / EDWOSB</div>
              <p>Federal Women-Owned & Economically Disadvantaged Women-Owned Small Business set-aside programs.</p>
              <a className="lk" href="/contact-us/">Check eligibility <span className="arw">→</span></a>
            </article>
          </div>
          <div className="allcerts-cta">
            <a className="btn btn-primary" href="/contact-us/">Find out which certifications you qualify for <span className="arw">→</span></a>
          </div>
        </div>
      </section>

      <section className="journey">
        <div className="wrap-wide">
          <div className="sec-head center">
            <span className="eyebrow center">How we work</span>
            <h2>Three steps from paperwork to your first federal contract.</h2>
          </div>
          <div className="journey-grid">
            <div className="jstep">
              <span className="seal-lg"><span className="sn">1</span><svg className="ico"><use href="#i-landmark" /></svg></span>
              <h3>Register</h3>
              <p>We get your business listed and active in SAM.gov — the federal government's official vendor system.</p>
            </div>
            <div className="jarrow" aria-hidden="true"><svg viewBox="0 0 74 44"><path className="ad-line" d="M4 22 L60 22" /><path className="ad-head" d="M49 13 L62 22 L49 31" /></svg></div>
            <div className="jstep">
              <span className="seal-lg"><span className="sn">2</span><svg className="ico"><use href="#i-award" /></svg></span>
              <h3>Certify</h3>
              <p>We qualify you for the SBA certifications that set your business apart and open set-aside contracts.</p>
            </div>
            <div className="jarrow" aria-hidden="true"><svg viewBox="0 0 74 44"><path className="ad-line" d="M4 22 L60 22" /><path className="ad-head" d="M49 13 L62 22 L49 31" /></svg></div>
            <div className="jstep">
              <span className="seal-lg"><span className="sn">3</span><svg className="ico"><use href="#i-trophy" /></svg></span>
              <h3>Win</h3>
              <p>You bid on federal contracts with confidence fully compliant and ready to compete.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="pricing sec-pad" id="pricing">
        <div className="wrap-wide">
          <div className="sec-head center">
            <span className="eyebrow center">Our programs</span>
            <h2>Choose the program that matches where you are.</h2>
            <p className="lead">Three guided programs take you from your first federal registration to full-scale contract pursuit. Every program is tailored after a free consultation — reach out and we'll map the right path for your business.</p>
          </div>
          <div className="price-grid">
            <article className="plan">
              <div className="pname">Subcontractor Partnership Program</div>
              <div className="pdesc">For businesses ready to start winning work as a subcontractor under federal prime contractors.</div>
              <ul>
                <li><svg className="ico"><use href="#i-shield" /></svg> SAM.gov registration & UEI setup</li>
                <li><svg className="ico"><use href="#i-shield" /></svg> NAICS & size-standard positioning</li>
                <li><svg className="ico"><use href="#i-shield" /></svg> Capability statement to share with primes</li>
                <li><svg className="ico"><use href="#i-shield" /></svg> Guidance on finding subcontract opportunities</li>
              </ul>
              <a className="btn btn-ghost" href="/contact-us/">Contact Now</a>
            </article>
            <article className="plan featured">
              <span className="ribbon">Most Popular</span>
              <div className="pname">Federal Growth Program</div>
              <div className="pdesc">For established businesses ready to compete for set-aside prime contracts of their own.</div>
              <ul>
                <li><svg className="ico"><use href="#i-shield" /></svg> Everything in the Partnership Program</li>
                <li><svg className="ico"><use href="#i-shield" /></svg> SBA certification (8(a), WOSB, HUBZone, SDVOSB)</li>
                <li><svg className="ico"><use href="#i-shield" /></svg> Annual renewals & compliance monitoring</li>
                <li><svg className="ico"><use href="#i-shield" /></svg> Bid & proposal strategy support</li>
                <li><svg className="ico"><use href="#i-shield" /></svg> Priority specialist support</li>
              </ul>
              <a className="btn btn-primary" href="/contact-us/">Contact Now</a>
            </article>
            <article className="plan">
              <div className="pname">Federal Expansion Program</div>
              <div className="pdesc">For growing firms ready to scale federal revenue across agencies and contract vehicles.</div>
              <ul>
                <li><svg className="ico"><use href="#i-shield" /></svg> Everything in the Growth Program</li>
                <li><svg className="ico"><use href="#i-shield" /></svg> GSA Schedule readiness & onboarding</li>
                <li><svg className="ico"><use href="#i-shield" /></svg> Multi-certification & recertification management</li>
                <li><svg className="ico"><use href="#i-shield" /></svg> Contract marketing & agency outreach</li>
                <li><svg className="ico"><use href="#i-shield" /></svg> Dedicated growth strategist</li>
              </ul>
              <a className="btn btn-ghost" href="/contact-us/">Contact Now</a>
            </article>
          </div>
          <p className="price-note">Each program is scoped and quoted individually after a free, no-obligation consultation.</p>
        </div>
      </section>

      <section className="finalcta" id="contact">
        <div className="wrap">
          <span className="starrow center" style={{ marginBottom: '24px' }}><svg viewBox="0 0 24 24"><use href="#i-star" /></svg><svg viewBox="0 0 24 24"><use href="#i-star" /></svg><svg viewBox="0 0 24 24"><use href="#i-star" /></svg></span>
          <img className="brand-logo" style={{ height: '60px', margin: '0 auto' }} src="/atz-logo-white.png" alt="ATZ Solution" />
          <span className="eyebrow">Ready when you are</span>
          <h2>Tell us where you are. We'll handle the federal part.</h2>
          <p>From first-time registration to full certification and contract pursuit, we simplify every step. Book a free consultation and a specialist will map your exact path into the federal marketplace.</p>
          <div className="hero-actions">
            <a className="btn btn-light" href="/contact-us/">Book a Free Consultation <span className="arw">→</span></a>
            <a className="btn btn-outline-light" href="/contact-us/">Talk to a Specialist</a>
          </div>
          <div className="call">Prefer to talk now? Call <b>(704) 459-8642</b> · Mon–Fri 9:00–6:00 ET</div>
        </div>
      </section>

    </main>
  );
}
